/* eslint-disable react/self-closing-comp */

/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import React from "react";
import { useHistory } from "react-router-dom";
import { ScanStatus, ScanSummary } from "types/api/scanSummary";
import { FilterInfo } from "types/pagination";
import { updateURLSearch } from "utils/urlUtil";
import { isSBOMScan } from "views/scanresult/scanUtil";

import ACTag from "ac-components/ac-tag/ACTag";

type Props = {
  record: ScanSummary;
  id: string;
};

export default function ScanIDCell({ id, record }: Props) {
  const history = useHistory();
  const featureFlags = useFeatureFlag();

  const {
    findings: { newFindings: { count: newFindingsCount = 0 } = {} } = {},
    scanStatus,
  } = record;
  const isDisabled =
    newFindingsCount <= 0 || scanStatus !== ScanStatus.COMPLETED;

  const redirectToFindings = () => {
    const sbomFlagsEnabled =
      featureFlags.DECOUPLE_SBOM_INGESTION && featureFlags.MANAGE_SBOM;
    if (isSBOMScan(record) && sbomFlagsEnabled) {
      // Redirect to SBOM/components page with product and subProduct filters
      updateURLSearch(
        history,
        {
          filters: {
            product: [record.product?.id!],
            subProduct: [record.subproduct?.id!],
          },
          pagination: {
            page: 0,
          },
        },
        "/sbom",
      );
    } else {
      const filters: FilterInfo = {
        scan: [`${id}`],
        product: [record.product?.id!],
        subProduct: [record.subproduct?.id!],
        environmentName: [record.environment],
      };
      updateURLSearch(
        history,
        {
          filters,
          pagination: {
            page: 0,
          },
        },
        "/findings",
      );
    }
  };

  const clickHandler = () => {
    if (isDisabled) {
      return;
    }
    redirectToFindings();
  };

  return (
    <div className="d-flex justify-content-between">
      <div>S-{id}</div>
      <ACTag
        className={`m-l-sm ${isDisabled ? "" : "clickable"}`}
        onClick={clickHandler}
        label={`View New Findings`}
        style={{ background: "#FCFCFD" }}
      ></ACTag>
    </div>
  );
}
